import React from "react";
import DraftRoomComponentV2 from "../../components/DraftRoomComponentV2/DraftRoomComponentV2";
import { useParams } from "react-router-dom";

function DraftRoomV2() {
  const { id } = useParams();

  return <DraftRoomComponentV2 eventId={id} />;
}

export default DraftRoomV2;
